module.exports = __webpack_public_path__ + "img/5f_r_goodsmile@2x.be5e5682.png";